import { translate } from '@openclassrooms/translations';

var confirm;

if (typeof window.App !== 'undefined' && window.App.modules) {
  confirm = window.App.modules.getInstance('modules/confirm');
  confirm.injectTranslator(translate);
} else {
  confirm = {
    show: function () {
      throw new Error('confirm service was not correctly initialized.');
    },
  };
}

export default confirm;
